export class RigaGaranzia {
    descrizione: string;
    codice: string;    
    testo:string;
    qta:number=1;
    id:number=0;
}



// WEBPACK FOOTER //
// ./src/app/models/rigagaranzia.ts